/**
 * Datos de sede para los flujos del portal autenticado (términos de contratación, razón social).
 * Indexado por `headquarter` en mayúsculas ('CEDESCA' | 'CNTEC'), que es el `empresaId` del alumno.
 */
export const SEDES_PORTAL = {
  CEDESCA: {
    nombre: 'CEDESCA',
    razonSocial: "CENTRE D'ESTUDIS CATALUNYA",
    terminosPdf: '/docs/terminosCedesca.pdf',
    terminosId: 'tyc-cedesca-v1',
  },
  CNTEC: {
    nombre: 'CNTEC',
    razonSocial: 'CNTEC EDUCATION',
    terminosPdf: '/docs/terminosCntec.pdf',
    terminosId: 'tyc-cntec-v1',
  },
};

/**
 * Devuelve la sede del alumno o `null` si no se reconoce. No hay sede por
 * defecto a propósito: con una sede desconocida el pago no se ofrece (el
 * backend además exige los términos vigentes de la sede real del recibo).
 */
export const getSedePortal = (headquarter) => {
  const clave = String(headquarter || '')
    .trim()
    .toUpperCase();
  return SEDES_PORTAL[clave] || null;
};
